<template>
  <v-container grid-list-xs fluid>
    <!-- DATA TABLE -->
    <v-card class="layout row wrap shadow pa-3">
      <div class="flex-row justify-space-between align-center grey lighten-4">
        <v-menu offset-y>
          <strong class="title_label pl-2" slot="activator">
            <span>{{ filter.title }}</span>
          </strong>
          <v-list>
            <v-list-tile
              :key="index"
              @click="filter = item"
              v-for="(item, index) in filters"
            >
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-spacer />
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              dark
              v-on="on"
              to="/CSOs/new"
              class="shadow-md"
              color="secondary"
              :loading="loading"
              v-if="can('add_CSOs')"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Add New Item</span>
        </v-tooltip>
      </div>
      <v-flex xs12 class="di-flex justify-space-between align-center my-3">
        <v-text-field
          small
          outline
          single-line
          hide-details
          class="rounded"
          v-model="search"
          style="max-width:320px"
          :placeholder="$t('search')"
          prepend-inner-icon="mdi-magnify"
        />
        <v-spacer />
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              flat
              v-on="on"
              color="grey darken-2"
              class="ma-0 mr-2 pa-0"
              @click="printTable(false)"
            >
              <v-icon>print</v-icon>
            </v-btn>
          </template>
          <span>Print Table</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              flat
              v-on="on"
              color="grey darken-2"
              class="ma-0 mr-2 pa-0"
              @click="printTable(true)"
            >
              <v-icon>file_download</v-icon>
            </v-btn>
          </template>
          <span>Excel Export</span>
        </v-tooltip>
      </v-flex>

      <v-data-table
        ref="tbl"
        :search="search"
        class="flex xs12"
        :headers="headers"
        :loading="loading"
        disable-initial-sort
        :items="filteredItems"
        :rows-per-page-items="per_page"
      >
        <template slot="items" slot-scope="props">
          <tr @click="props.expanded = !props.expanded">
            <td
              :class="{
                Reminded: reAssesst(props.item),
                Expired: expired(props.item)
              }"
            >
              {{ props.index + 1 }}
            </td>
            <td class="font-weight-bold">
              <router-link :to="`/CSOs/${props.item.id}`">{{
                props.item.name
              }}</router-link>
            </td>
            <td>{{ props.item.assessment_date }}</td>
            <td>{{ props.item.latest_assessment.reminder_date }}</td>
            <td>{{ props.item.latest_assessment.expire_date }}</td>
            <td>{{ props.item.email }}</td>
            <td>{{ props.item.phone }}</td>
            <td>{{ props.item.website }}</td>
            <td>{{ props.item.president }}</td>
            <td>{{ props.item.assessment_funded_by }}</td>
            <td :class="props.item.latest_assessment.decision">
              {{ props.item.latest_assessment.decision }}
            </td>
            <td>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    flat
                    small
                    v-on="on"
                    class="ma-0 pa-0"
                    color="grey darken-2"
                    v-if="can('view_CSOs')"
                    :to="`/CSOs/${props.item.id}`"
                  >
                    <v-icon>mdi-launch</v-icon>
                  </v-btn>
                </template>
                <span>View</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    flat
                    small
                    v-on="on"
                    class="ma-0 pa-0"
                    color="grey darken-2"
                    v-if="can('edit_CSOs')"
                    :to="`/CSOs/edit/${props.item.id}`"
                  >
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Edit</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    flat
                    small
                    v-on="on"
                    class="ma-0 pa-0"
                    color="grey darken-2"
                    v-if="can('delete_CSOs')"
                    @click="deleteItem(props.item)"
                  >
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <span>Delete</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
        <template v-slot:expand="{ item }">
          <v-card flat class="pa-2">
            <score-card-summary :summary="item.latest_assessment.summary" />
          </v-card>
        </template>
        <template slot="footer">
          <tr>
            <td colspan="100%">
              <div class="flex-row justify-space-between">
                <div class="di-flex">
                  <div class="circle Pending mx-2"></div>
                  <strong>Pending</strong>
                </div>
                <div class="di-flex">
                  <div class="circle Certified mx-2"></div>
                  <strong>Certified</strong>
                </div>
                <div class="di-flex">
                  <div class="circle Deferred mx-2"></div>
                  <strong>Deferred</strong>
                </div>
                <div class="di-flex">
                  <div class="circle Reminded mx-2"></div>
                  <strong>Reminded</strong>
                </div>
                <div class="di-flex">
                  <div class="circle Expired mx-2"></div>
                  <strong>Expired</strong>
                </div>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  name: "CSOs",
  data() {
    return {
      items: [],
      search: null,
      dialog: false,
      loading: false,
      filters: [
        { title: "All CSOs", value: false, filterFunc: () => true },
        {
          value: "Pending",
          title: "Pending CSOs",
          filterFunc: item => item.latest_assessment.decision == "Pending"
        },
        {
          value: "Certified",
          title: "Certified CSOs",
          filterFunc: item => item.latest_assessment.decision == "Certified"
        },
        {
          value: "Deferred",
          title: "Deferred CSOs",
          filterFunc: item => item.latest_assessment.decision == "Deferred"
        },
        {
          title: "Needs - Re-Assessment",
          filterFunc: this.reAssesst
        },
        {
          title: "Expired",
          filterFunc: this.expired
        }
      ],
      filter: { title: "All CSOs", value: false, filterFunc: () => true }
    };
  },

  computed: {
    headers: vm => [
      { text: "NO", sortable: false, width: "100px" },
      { text: "CSOs Name", value: "name" },
      { text: vm.$t("assessment_date"), value: "assessment_date" },
      {
        text: vm.$t("reminder_date"),
        value: "latest_assessment.reminder_date"
      },
      { text: vm.$t("expire_date"), value: "latest_assessment.expire_date" },

      { text: vm.$t("email"), value: "email" },
      { text: vm.$t("phone"), value: "phone" },
      { text: vm.$t("website"), value: "website" },
      { text: vm.$t("president"), value: "president" },
      { text: vm.$t("assessment_funded_by"), value: "assessment_funded_by" },
      { text: vm.$t("status"), value: "latest_assessment.decision" },
      { text: vm.$t("actions"), sortable: false, width: "200px" }
    ],
    filteredItems() {
      return this.items.filter(x => this.filter.filterFunc(x));
    }
  },

  methods: {
    reAssesst: item =>
      item.latest_assessment.reminder_date &&
      +new Date(item.latest_assessment.reminder_date) <= +new Date(),

    expired: item =>
      item.latest_assessment.expire_date &&
      +new Date(item.latest_assessment.expire_date) <= +new Date(),

    deleteItem(item) {
      let vm = this;
      this.$alert(`/CSOs/${item.id}`).then(() => {
        vm.items.splice(vm.items.indexOf(item), 1);
      });
    },

    printTable(excel) {
      let headers = this.headers.slice(1, this.headers.length - 1);
      if (excel)
        headers.push(
          { text: this.$t("registration_date"), value: "registration_date" },
          {
            text: this.$t("program_areas"),
            value: "program_areas",
            computed: cso => cso.program_areas.map(x => x.name).join(", ")
          },
          {
            text: this.$t("operational_areas"),
            value: "operational_areas",
            computed: cso => cso.operational_areas.map(x => x.name).join(", ")
          },
          { text: this.$t("registered_office"), value: "registered_office" },
          { text: this.$t("board_of_directors"), value: "board_of_directors" },
          { text: this.$t("staff_size"), value: "staff_size" },
          { text: this.$t("paid_fee"), value: "paid_fee" }
        );

      let data = {
        headers,
        title: `Lists of CSOs`,
        items: this.$refs.tbl.filteredItems
      };

      if (excel) return this.xl_tables(data, "CSOs");
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    }
  },

  created() {
    this.loading = true;
    this.axios
      .get(`/CSOs`)
      .then(res => {
        this.items = res.data.data;
        this.$emit("loaded", res.data.data);
        this.loading = false;
      })
      .catch(() => (this.loading = false));
  }
};
</script>
<style>
.circle {
  width: 15px;
  height: 15px;
}
</style>
